import { Injectable } from 'angular-ts-decorators';

import { Domain } from '@shared/app/scripts/services/domain';

/**
 * Service in the coreModule.
 */
@Injectable('navigate')
export class Navigate {
  constructor(
    private $window: ng.IWindowService,
    private $routeParams: ng.route.IRouteParamsService,
    private domain: Domain,
  ) {
    'ngInject';
  }

  /**
   * Direct to a route on a sibling domain with the ability to include a back reference
   * to the previous URL.
   * @param app name of the app. If undefined, defaults to
   * the current app
   * @param route the route it should direct to, by convention starts with '/'
   * @param backReference optional parameter when true a backReference
   * will be included in the url
   */
  to(app: string, route: string, backReference?: boolean): void {
    if (!app) {
      app = this.domain.getApp();
    }

    let redirect = this.domain.link(`${app}#${route}`);

    if (backReference) {
      redirect +=
        '?backReference=' + encodeURIComponent(this.$window.location.href);
    }

    this.$window.location.href = redirect;
  }

  /**
   * Go back to the previous route saved in the back reference
   * @return {void}
   */
  back(): void {
    if (this.$routeParams.backReference) {
      this.$window.location.href = this.$routeParams.backReference;
    }
  }
}
